import Vue from 'vue'
import Router from 'vue-router'
import Contact from "./views/Contact";
import Confirm from "./views/Confirm";
import Complete from "./views/Complete";
import BeerRegistration from "./views/BeerRegistration";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            components: {
                default: BeerRegistration,
                contact: Contact,
                confirm: Confirm,
                complete: Complete,
            }
        },
    ]
})
